import React from 'react';
import appRoutes from './../configs/AppRoutes';
import { Routes, Route } from 'react-router-dom';
import Login from './../components/Auth/Login/Login';
import Otp from './../components/Auth/Otp/Otp';
import VerifyEmail from './../components/Auth/VerifyEmail';
import ForgotPassword from '../components/Auth/ForgotPassword';
import ResetPassword from '../components/Auth/ResetPassword';
import Profile from '../components/User/Profile';
import {  useLocation } from 'react-router-dom';

import ThankYou from './../components/Auth/ThankYou';
import PdfPage from '../components/Proposal/Proposal';
import ProposalInfo from '../components/Proposal/ProposalInfo';
import OnlyTestDoc from '../components/Proposal/TestDoc';


import ListProposal from '../components/ProposalList/ListProposal';



// Containers
 const DefaultLayout = React.lazy(() => import('./../layout/DefaultLayout'));
const AuthLayout = React.lazy(() => import('./../layout/AuthLayout'));
// const CmsLayout = React.lazy(() => import('./../layout/CmsLayout'));

const UserRoute = () => {
    const location = useLocation();
    const pathnameParts = location.pathname.split('/'); // ['', 'create-proposal', '181']
    const id = pathnameParts[2]; // Will be undefined if no ID

    const pdfEditorRoute = id ? appRoutes.pdfEditorUpdatePageRoute : appRoutes.pdfEditorPageRoute;


    return (
        <Routes>
            <Route exact path="/" element={<DefaultLayout />} >
                <Route exact index path={appRoutes.loginPageRoute} element={<Login />} />
                <Route exact path={appRoutes.loginPageRoute} element={<Login />} />
                <Route exact path={appRoutes.thankYouPageRoute} element={<ThankYou />} />
                <Route exact path={appRoutes.otpPageRoute} element={<Otp />} />
                <Route exact path={appRoutes.verifyEmailPageRoute} element={<VerifyEmail />} />
                <Route exact path={appRoutes.forgotPasswordPageRoute+ "/:id?"} element={<ForgotPassword />} />
                <Route path={`${pdfEditorRoute}/:id?`} element={<PdfPage />} />
                <Route path={appRoutes.profilePageRoute} element={<Profile />} />
                <Route path={appRoutes.listProposalRoute} element={<ListProposal />} />
                <Route path={appRoutes.proposalInfo} element={<ProposalInfo />} />
                <Route path={appRoutes.testDoc} element={<OnlyTestDoc />} />


                
                <Route path={`appRoutes.resetPasswordRoute/:id?`} element={<ResetPassword />} />

                


            </Route>
        </Routes>
    );
};

export default UserRoute;
